import { useQuery } from 'react-query';
import { Car, Family, Funeral, Home, Legal } from '../../../../../../types/SMT';
import { InsurancePolicy } from '../../../../../advisory-report/src/types/AdvisoryReport';
import { wgApi } from '../../../../../app/src/features/api/wgApi';
import {
  Bicycle,
  Boat,
  SemiTrailer,
  Trailer,
  TwoWheeler,
} from '../../../types/RiskObject';

export interface BasicRiskObjectData {
  already_insured?: boolean;
  amount_of_coverages?: number;
  insurance_policies?: InsurancePolicy[];
  risk_object_id?: string;
  risk_object_revision_id?: string;
  name?: string;
}

export interface RiskObjects {
  cars: Array<Car & BasicRiskObjectData>;
  residences: Array<Home & BasicRiskObjectData>;
  families: Array<Family & BasicRiskObjectData>;
  two_wheelers: Array<TwoWheeler & BasicRiskObjectData>;
  legal: Array<Legal & BasicRiskObjectData>;
  teachers: Array<unknown & BasicRiskObjectData>;
  party_groups: Array<Funeral & BasicRiskObjectData>;
  boats: Array<Boat & BasicRiskObjectData>;
  bicycles: Array<Bicycle & BasicRiskObjectData>;
  trailers: Array<Trailer & BasicRiskObjectData>;
  semi_trailers: Array<SemiTrailer & BasicRiskObjectData>;
  miscellanea: Array<unknown & BasicRiskObjectData>;
}

const getAllRiskObjectsByParty = async (partyId: string, version: string) => {
  const { data, isError } = await wgApi.get<RiskObjects>(
    `${version}/api/parties/${partyId}/risk_objects`,
  );
  if (isError) throw new Error();
  return data;
};

export const getUseAllRiskObjectByPartyIdQKey = (
  partyId: string,
  version: string,
) => ['portfolio', 'risk-objects', partyId, version];

export const useRiskObjectsByParty = (partyId?: string, version = 'v1') => {
  return useQuery(
    getUseAllRiskObjectByPartyIdQKey(partyId!, version),
    async () => await getAllRiskObjectsByParty(partyId!, version),
    {
      refetchOnWindowFocus: false,
      enabled: !!partyId,
    },
  );
};
